import React from 'react';
import { styled } from '@mui/material';

import TilesIcon from './icons/Tiles';
import TableIcon from './icons/List';

const Container = styled('div')({
  display: 'flex',
  gap: '4px',
  alignItems: 'center',
});

const Button = styled('button')(({ active }: { active: boolean }) => ({
  cursor: 'pointer',
  height: '24px',
  width: '24px',
  fontSize: '12px',
  background: 'transparent',
  color: active ? '#6B778C' : '#C1C7D0',
  border: active ? '1px solid #DFE1E6' : 'none',
  padding: active ? '5px' : '6px',
  borderRadius: '3px',
}));

export default ({ currentMode }: { currentMode: 'tiles' | 'table' }) => (
  <Container>
    <Button active={currentMode === 'tiles'}>
      <TilesIcon/>
    </Button>
    <Button active={currentMode === 'table'}>
      <TableIcon/>
    </Button>
  </Container>
);
